@if (story()) {
  <app-scroll-progress-indicator></app-scroll-progress-indicator>
  <app-website-header [allowSticky]="true"></app-website-header>
  <article [appStoryblok]="story().content._editable" class="storyblok-page with-spacing">
    <div class="page smallish">
      <app-article-breadcrumb [story]="story()"></app-article-breadcrumb>
      <h1 [class.large]="story().content.largeTitle">{{ story().content.title }}</h1>
      @if (story().content.lead) {
        <p [innerHTML]="story().content.lead.replaceAll('\n', '<br/>') | safeHtml"></p>
      }
      <div class="article-buttons">
        <app-article-speech [story]="story()"></app-article-speech>
        <a
          appButton
          name="chat"
          location="storyblok-article"
          [hasIcon]="true"
          shape="round"
          weight="bold"
          [href]="gptLink()"
          target="_blank"
        >
          <app-svg src="/assets/icons/logo/chatgpt.svg"></app-svg>
          <span>Chat</span>
        </a>
        <app-article-share [story]="story()"></app-article-share>
      </div>

      <app-new-blog-meta [story]="story()"></app-new-blog-meta>
    </div>
    @if (visual()?.filename) {
      <div class="page">
        @if (visual().filename.includes('mp4')) {
          <video
            [src]="visual().filename | storyblokCdn"
            #videoEl
            loop
            muted
            playsinline
            disablepictureinpicture="true"
          ></video>
        } @else {
          <app-picture
            [scale]="1"
            [url]="visual().filename | storyblokCdn"
            [width]="dimensions().width"
            [height]="dimensions().height"
            [alt]="visual().alt || ''"
            [appStoryblok]="visual()._editable"
          >
          </app-picture>
        }
      </div>
    }
    <app-table-of-contents [story]="story()" [style]="contentStyle"></app-table-of-contents>

    @defer (hydrate on idle) {
      @if (story().content.body) {
        <app-text [content]="story().content.body" [style]="contentStyle" alignment="left"></app-text>
      }
    }
  </article>
  @if (relatedPosts()?.length) {
    <app-blog-post-link-list [style]="relatedPostsStyle" [hardcodedPosts]="relatedPosts()"></app-blog-post-link-list>
  }

  @defer (hydrate on hover) {
    <app-pre-footer>
      <a
        [routerLink]="['/auth/signup']"
        appButton
        name="signup-cta"
        location="pre-footer"
        color="primary"
        height="4"
        spacing="4"
        size="3"
        weight="default"
        shape="round"
        [center]="true"
      >
        <b>Try Picflow for Free</b>
      </a>
    </app-pre-footer>
    <app-website-footer></app-website-footer>
  }
}
